import { onMounted, ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm, useFieldArray } from 'vee-validate'
import { orderSchema } from '@/schemas/orderSchema'
import { useRouter } from 'vue-router'
import { getNextOrderNumber, getOrderById } from '@/api/orders'

export const useOrderForm = (formType: 'add' | 'edit' | 'view'): any => {
  const { values, handleSubmit, errors, setErrors, resetForm, meta, setFieldValue } = useForm({
    validationSchema: toTypedSchema(orderSchema)
  })

  const {
    push: newProduct,
    remove: removeProduct,
    fields: productFields
  } = useFieldArray('orderProducts')

  const toast = useToast()
  const loading = ref(false)
  const router = useRouter()

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  onMounted(async () => {
    if (formType !== 'add') {
      const orderId = router.currentRoute.value.params.id as string
      const order = await getOrderById(orderId)
      if (order) {
        resetForm({
          values: { ...order }
        })
      }
    } else {
      try {
        const newOrderNumber = await getNextOrderNumber()
        setFieldValue('orderNumber', newOrderNumber)
      } catch (error) {
        console.error('Failed to fetch order number', error)
      }
    }
  })

  return {
    values,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    meta,
    loading,
    showToast,
    formType,
    newProduct,
    removeProduct,
    productFields,
    setFieldValue
  }
}
